import React from 'react';
import ContactForm from './ContactForm';
import './contact.css';
import SEO from './SEO'; // if you have your SEO helper

export default function ContactPage() {
  return (
    <div className="container">
      <SEO
        title="Contact Us – We Are Local"
        description="Send us a note—ideas, tips, or feedback. We read every message."
        canonical="https://yourdomain.com/contact"
        og={{ type: 'website' }}
      />
      <h1>Contact Us</h1>
      <p>Questions, ideas, or feedback? We’d love to hear from you.</p>
      <ContactForm />
    </div>
  );
}